module.exports = __webpack_public_path__ + "img/e_3_28_g.f1ea0e88.png";